const envApiUrl =
	process.env.REACT_APP_API_URL ||
	process.env.REACT_APP_API_URL_PROD;

const inferredApiUrl =
	typeof window !== "undefined" && window?.location?.hostname
		? `${window.location.protocol}//${window.location.hostname}:8080`
		: "https://www.bharatvidyarthi.com/backend";

const apiUrl = envApiUrl || inferredApiUrl;

export default apiUrl;
